type NavItem = {
  [key: string]: any
  'subNav'?: any
}

const filterNav = <T extends NavItem, K extends keyof T>(nav: T[] = [], subNavKey: K): Array<T | Omit<T, K>> => {
  if (!subNavKey) {
    // @ts-ignore: Is not assignable
    subNavKey = 'subNav'
  }

  return nav
    .filter((item) => item)
    .map(({ [subNavKey]: subNav, ...rest }) => {
      if (subNav && subNav.length > 0) {
        const filteredSubNav = subNav.filter((item: NavItem) => item)

        return {
          ...rest,
          [subNavKey]: filteredSubNav,
        }
      }

      return rest
    })
}


export default filterNav
